// extracted by mini-css-extract-plugin
module.exports = {"inputSelect":"CustomSelectNew_inputSelect__2eS6E"};